module.exports = __webpack_public_path__ + "img/discount_popup_coin.4009d78d.png";